export class Spinner {
    private static instances: Map<string, Spinner> = new Map();
    private spinnerElement: HTMLElement;
    private progressBarElement: HTMLElement | null = null;
    private isVisible: boolean = false;
    private progressValue: number = 0;
    private progressInterval: ReturnType<typeof setInterval> | null = null;
    private withProgressBar: boolean;

    private constructor(private spinnerId: string, withProgressBar: boolean = false) {
        this.withProgressBar = withProgressBar;
        this.spinnerElement = this.initSpinnerElement();

        if (this.withProgressBar) {
            this.progressBarElement = this.initProgressBarElement();
        }
    }

    static getInstance(spinnerId: string = "loading-spinner", withProgressBar: boolean = false): Spinner {
        if (!this.instances.has(spinnerId)) {
            this.instances.set(spinnerId, new Spinner(spinnerId, withProgressBar));
        }
        return this.instances.get(spinnerId)!;
    }

    private initSpinnerElement(): HTMLElement {
        const existing = document.getElementById(this.spinnerId);
        if (existing) return existing;

        const wrapper = document.createElement("div");
        wrapper.id = this.spinnerId;
        wrapper.className = "loading-spinner";
        wrapper.style.cssText = `
            position: fixed;
            inset: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: rgba(255,255,255,0.9);
            backdrop-filter: blur(6px);
            z-index: 9999;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
            pointer-events: none;
        `;

        const spinnerIcon = document.createElement("div");
        spinnerIcon.className = "spinner";
        wrapper.appendChild(spinnerIcon);

        document.body.appendChild(wrapper);
        return wrapper;
    }

    private initProgressBarElement(): HTMLElement {
        const container = document.createElement("div");
        container.className = "progress-container";

        const bar = document.createElement("div");
        bar.id = `${this.spinnerId}-progress`;
        bar.className = "progress-bar";

        container.appendChild(bar);
        this.spinnerElement.appendChild(container);
        return bar;
    }

    public show(): void {
        if (this.isVisible) return;
        this.isVisible = true;

        this.spinnerElement.style.display = "flex";
        requestAnimationFrame(() => {
            this.spinnerElement.style.opacity = "1";
        });

        if (this.withProgressBar && this.progressBarElement) {
            this.progressValue = 0;
            this.progressBarElement.style.width = "0%";
            this.progressBarElement.style.background = "#f07f5e";
            this.startProgressAnimation();
        }
    }

    public hide(): void {
        if (!this.isVisible) return;
        this.isVisible = false;

        if (this.withProgressBar && this.progressBarElement) {
            this.progressValue = 100;
            this.progressBarElement.style.width = "100%";
            this.progressBarElement.style.background = "#4CAF50";
        }

        setTimeout(() => {
            this.spinnerElement.style.opacity = "0";
            setTimeout(() => {
                this.spinnerElement.style.display = "none";
                this.cleanup();
            }, 300);
        }, 500);
    }

    private startProgressAnimation(): void {
        if (this.progressInterval) clearInterval(this.progressInterval);

        this.progressInterval = setInterval(() => {
            if (!this.isVisible || this.progressValue >= 100) {
                clearInterval(this.progressInterval!);
                this.progressInterval = null;
                return;
            }
            this.progressValue += Math.random() * 8 + 4;  // Etwas flüssigere Progress-Simulation
            if (this.progressBarElement) {
                this.progressBarElement.style.width = `${Math.min(this.progressValue, 100)}%`;
            }
        }, 400);
    }

    private cleanup(): void {
        if (this.progressInterval) clearInterval(this.progressInterval);
        this.progressInterval = null;
        Spinner.instances.delete(this.spinnerId);
    }
}
